import { Component, Inject, OnInit } from '@angular/core';
import { ApiRequestService } from '@prekog/common-ui';
import { HomeInfo } from './home-info';
import { HomeInfoResponse } from './homeinforesponse';

@Component({
    selector: 'pf-home-info',
    templateUrl: './home-info.component.html',
    styleUrls: ['./home-info.component.scss'],
    standalone: true
})
export class HomeInfoComponent implements OnInit {
    configuratorBaseUrl = '';
    getHomeInfoUrl = '/websiteconfigurator/get-homeinfo';

    homeInfoList: HomeInfo[] = [];

    constructor(
        private _apiRequestService: ApiRequestService,
        @Inject('CONFIGURATOR_BASE_URL') private _configuratorBaseUrl: string,
    ) {
        this.configuratorBaseUrl = _configuratorBaseUrl;
    }

    ngOnInit(): void {
        this._apiRequestService
            .sendRequest<{}, HomeInfoResponse>(this.configuratorBaseUrl, {}, true, this.getHomeInfoUrl)
            .subscribe((response) => {
                this.homeInfoList = response.homeInfoList as HomeInfo[];
            });
    }
}
